import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { fetchChambers, fetchDistricts } from '../../Services/apiService';
import '../../Styles/chambers.css';

const ChamberList = ({ category }) => {
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [chambers, setChambers] = useState([]);
  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadDistricts = async () => {
      const data = await fetchDistricts();
      setDistricts(data || []);
    };
    loadDistricts();
  }, []);

  useEffect(() => {
    const loadChambers = async () => {
      if (selectedDistrict) {
        const data = await fetchChambers(category, selectedDistrict);
        setChambers(data || []);
      }
    };
    loadChambers();
  }, [selectedDistrict, category]);

  return (
    <div id="chambers">
      <h2 className="header">
        {category}
        {' '}
        in Selected District
      </h2>
      <h2
        className="district text-xl font-semibold text-gray-700"
      >
        জেলা
      </h2>
      <select
        onChange={(e) => setSelectedDistrict(e.target.value)}
        value={selectedDistrict || ''}
      >
        <option value="" disabled>Please Select A District</option>
        {districts.map((district) => (
          <option key={district.id} value={district.id}>
            {district.name}
          </option>
        ))}
      </select>
      <ul>
        {chambers.map((chamber) => (
          <li id="chamber-list" key={chamber.id}>
            <h3>
              # &nbsp;
              {chamber.name}
            </h3>
            <p>{chamber.address}</p>
            <p className="text-blue-700">
              ফোনঃ &nbsp;
              {chamber.contact}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

// PROP VALIDATION
ChamberList.propTypes = {
  category: PropTypes.string.isRequired,
};

export default ChamberList;
